<template>
	<div class="agreement">
		<cjl-ys
			v-if="$store.getters['user/getAppid'] === 'wx41c1352ffcf95479'"
		></cjl-ys>
		<jlzy-ys
			v-if="$store.getters['user/getAppid'] === 'wxcd792ea26091b2f5'"
		></jlzy-ys>
		<yzy-ys v-else></yzy-ys>
	</div>
</template>

<script>
import YzyYs from "./components/yzy/ys.vue";
import CjlYs from "./components/cjl/ys.vue";
import JlzyYs from "./components/jlzy/ys.vue";
export default {
	components: {
		YzyYs,
		CjlYs,
		JlzyYs
	},
};
</script>
